var map = {
	"./banner-font.png": "fc2d",
	"./bg-service-item.png": "8431",
	"./dot.png": "be7c",
	"./introduce.png": "27af",
	"./process-1.png": "b90d",
	"./process-2.png": "b746",
	"./process-3.png": "1aaa",
	"./process-4.png": "7c6e",
	"./process-5.png": "a8f7",
	"./process-next.png": "204f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7cd8";